import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, of} from 'rxjs';
import { AuthService as AuthApiService } from '../../api-new';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import {AppRoutes} from "../guards/app-routes";
import {catchError, map, tap} from 'rxjs/operators';

export enum UserRole {
  human_resource_manager = 'human_resource_manager',
  health_care_manager = 'health_care_manager',
  pzs_manager = 'pzs_manager',
  system_manager = 'system_manager'
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loggedIn = new BehaviorSubject<boolean>(false);
  jwt?: string;

  constructor(
    private authApiService: AuthApiService,
    private router: Router,
    private toaster: NbToastrService,
  ) {
    this.jwt = this.getLocalToken();
    this.loggedIn.next(!!this.jwt);
  }

  logIn(userName: string, password: string): Observable<boolean> {
    return this.authApiService.authLogin({ userName, password }).pipe(
      tap(jwt => {
        this.jwt = jwt;
        this.saveLocalToken(jwt);
        this.loggedIn.next(true);
        this.router.navigate([AppRoutes.HOME]);
      }),
      map(() => true),
      catchError(error => {
        if (error?.status === 401) {
          this.toaster.danger('Nesprávne prihlasovacie údaje', 'Chyba');
        } else {
          this.toaster.danger('Prihlásenie zlyhalo. Skúste znova.', 'Chyba');
        }
        return of(false);
      })
    );
  }

  forceLogIn(userId: number) {
    this.authApiService.authForceLogin(userId).subscribe(
      jwt => {
        this.jwt = jwt;
        this.loggedIn.next(true);
        this.saveLocalToken(jwt);
        window.location.reload();
      },
      errorResponse => {
        if (errorResponse.status === 401) {
          this.toaster.danger('Nesprávne prihlasovacie údaje', 'Chyba');
        }
      }
    );
  }

  logOut() {
    this.jwt = undefined;
    localStorage.removeItem('jwt');
    localStorage.removeItem('attemptedUrl');
    this.loggedIn.next(false);
    this.router.navigate([AppRoutes.LOGIN]).then(() => {
      window.location.reload();
    });
  }

  private getLocalToken() {
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      return JSON.parse(jwt);
    }
    return undefined;
  }

  private saveLocalToken(jwt) {
    localStorage.setItem('jwt', JSON.stringify(jwt));
  }
}
